import React from 'react';
import { useNavigate } from 'react-router-dom';
import { buildSegmentEditPath } from '../../../../app-routes';
import type { SegmentDefinitionSummary } from '../../edit-automation-template/segment-definitions-api';
import styles from './SegmentTableRow.module.css';

interface SegmentTableRowProps {
  segment: SegmentDefinitionSummary;
}

const formatSegmentName = (name: string): string => {
  return name
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const formatDate = (dateString: string | null): string => {
  if (!dateString) {
    return 'N/A';
  }
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return 'N/A';
  }
};

export const SegmentTableRow: React.FC<SegmentTableRowProps> = ({
  segment,
}) => {
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(buildSegmentEditPath(segment.canonicalVersionId));
  };

  return (
    <tr className={styles.row}>
      <td>{formatSegmentName(segment.name)}</td>
      <td>{segment.description || '-'}</td>
      <td>{formatDate(segment.updatedAt)}</td>
      <td>
        <button type="button" onClick={handleEdit}>
          Edit
        </button>
      </td>
    </tr>
  );
};
